export const AD_CONFIG = {
  AD300X250: {
    adSlot: '/183758631/Web_300x250',
    id: 'div-gpt-ad-1651397919405-3',
    width: 300,
    height: 250
  },
  AD320X80: {
    adSlot: '/183758631/Web_320x80',
    id: 'div-gpt-ad-1651397919405-2',
    width: 320,
    height: 80
  },
  AD320X250: {
    adSlot: '/183758631/Web_320x250',
    id: 'div-gpt-ad-1651397919405-4',
    width: 320,
    height: 250
  },
  AD728X120: {
    adSlot: '/183758631/Web_728x120',
    id: 'div-gpt-ad-1651397919405-1',
    width: 728,
    height: 120,
  },
}
